import { observer } from 'mobx-react-lite';
import { PrizeModal } from '../prizeModal';
import { IRewardState, LotteryRewardTypes, ShortLinkType } from 'src/types';
import { ModalProps } from '../modal';

import './rewardDetailsModal.styl';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { useEffect, useState } from 'react';
import { ProviderDetailsModal } from './providerDetailsModal';

interface Props extends ModalProps {
    reward: IRewardState;
}

export const RewardDetailsModal = observer(({ reward, ...rest }: Props) => {
    const { getVisitedDaysAmount, openLink, logOperation } = useStoreContext();
    const { translate } = useTranslationsContext();
    const [isProviderModalOpened, setIsProviderModalOpened] = useState(false);
    const { modalBackground, modalTitle, modalImg, modalDescription, providerText, providerLink } =
        reward?.renderParams || {};

    useEffect(() => {
        reward && logOperation('rewards', 'reward_view', reward.id);
    }, [reward]);

    const getContent = () => {
        if (reward.lottery_reward_type === LotteryRewardTypes.CODE) {
            return (
                <div className="reward-details-promo">
                    <div className="reward-details-promo-text">{translate('reward.details.promo')}</div>
                    <div className="reward-details-promo-code">{reward.promo_code || ''}</div>
                </div>
            );
        }

        return undefined;
    };

    const getButtonTitle = () => {
        if (reward.renderParams.activateLink) {
            return reward.renderParams.activateText || translate('reward.details.button.promo');
        }

        return undefined;
    };

    const onButtonClick = () => {
        logOperation('rewards', 'reward_open', reward.id);
        if (reward.renderParams.activateLink) {
            openLink(reward.renderParams.activateLink!, true, { type: ShortLinkType.REWARD, subtype: reward.id });
        }
    };

    const getButtonSecondaryTitle = () => {
        if (providerText || providerLink) return translate('reward.details.button.promo-provider');

        return undefined;
    };

    const onSecondaryButtonClick = () => {
        if (providerText) {
            setIsProviderModalOpened(true);
        }

        openLink(reward.renderParams.providerLink!, true, { type: ShortLinkType.REWARD, subtype: reward.id });
    };

    if (!reward) {
        return null;
    }

    return (
        <>
            <PrizeModal
                background={modalBackground || '#B9DCF0'}
                imgSrc={modalImg}
                title={modalTitle || ''}
                description={modalDescription}
                primaryButtonText={getButtonTitle()}
                secondaryButtonText={getButtonSecondaryTitle()}
                onClickPrimaryBtn={onButtonClick}
                onClickSecondaryBtn={onSecondaryButtonClick}
                beforeTitleComponent={
                    reward && reward.lottery_reward_type === LotteryRewardTypes.LOGINS_SPECIAL ? (
                        <span className="reward-details-visited">
                            {translate('visited', {
                                count: getVisitedDaysAmount(),
                                countPlural: getVisitedDaysAmount()
                            })}
                        </span>
                    ) : undefined
                }
                {...rest}
            >
                {getContent()}
            </PrizeModal>
            {isProviderModalOpened ? (
                <ProviderDetailsModal
                    text={providerText || ''}
                    rewardId={reward.id}
                    isOpened={isProviderModalOpened}
                    onClose={() => {
                        setIsProviderModalOpened(false);
                    }}
                />
            ) : null}
        </>
    );
});
